import React from 'react';

const TermsModal = ({ isOpen, onAgree, onCancel, photoCount }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-fade-in">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-hidden animate-slide-up">
        {/* Header */}
        <div className="bg-primary-600 text-white p-6">
          <h2 className="text-2xl font-bold">📋 Terms & Agreement</h2>
          <p className="text-primary-100 mt-1">Please review before uploading</p>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4 max-h-96 overflow-y-auto scrollbar-thin">
          <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded">
            <p className="font-semibold text-blue-900 mb-1">📸 Photos to Upload</p>
            <p className="text-blue-700">{photoCount} photo(s) selected</p>
          </div>

          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <span className="text-2xl">🗑️</span>
              <div>
                <h3 className="font-semibold text-gray-900">Automatic Deletion</h3>
                <p className="text-sm text-gray-600">
                  We automatically delete all photos after printing and delivery to protect your privacy and save storage costs.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <span className="text-2xl">📐</span>
              <div>
                <h3 className="font-semibold text-gray-900">Image Quality</h3>
                <p className="text-sm text-gray-600">
                  Please ensure your images are high quality for the best print results. Low-resolution images may appear pixelated.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <span className="text-2xl">🔒</span>
              <div>
                <h3 className="font-semibold text-gray-900">Privacy & Security</h3>
                <p className="text-sm text-gray-600">
                  Your photos are stored securely and are only accessible to our print team. We never share your images.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <span className="text-2xl">✂️</span>
              <div>
                <h3 className="font-semibold text-gray-900">Cropping & Adjustments</h3>
                <p className="text-sm text-gray-600">
                  Minor cropping may occur to fit the selected print size. Review your edits before submitting.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <span className="text-2xl">⚠️</span>
              <div>
                <h3 className="font-semibold text-gray-900">Content Guidelines</h3>
                <p className="text-sm text-gray-600">
                  Please ensure all uploaded content is appropriate and that you have the right to print these images.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="flex gap-3 p-6 bg-gray-50 border-t">
          <button
            onClick={onCancel}
            className="flex-1 px-6 py-3 border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors font-medium"
          >
            Cancel
          </button>
          <button
            onClick={onAgree}
            className="flex-1 px-6 py-3 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors font-semibold"
          >
            I Agree & Upload
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;

